import { useEffect, useState } from "react";
import { io } from "socket.io-client";
import { ENV } from "@config/env";
import LOCAL_STORAGE from "@utils/localStorage";

const SOCKET_SERVER_URL = ENV.API_HOST;

export const useSocket = () => {
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const newSocket = io(SOCKET_SERVER_URL, {
      transports: ["websocket", "polling"],
      auth: {
        device_id: LOCAL_STORAGE.MAC_ADDRESS.GET(),
      },
    });
    setSocket(newSocket);

    return () => {
      newSocket.disconnect();
    };
  }, []);

  return socket;
};
